// components/Combined2FA.js
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { API_URL } from '../reusable/url';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import { setUserDetails } from '../reducers/user';

import './combined2FA.css'

const Combined2FA = () => {
  const [qrCode, setQrCode] = useState('');
  const [token, setToken] = useState('');
  const { state } = useLocation();
  const sessionToken = state ? state.sessionToken : null;
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionToken) {
      const enable2FA = () => {
        console.log('Auth Token:', sessionToken); // Add logging
        fetch(API_URL('enable-2fa', 'auth'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionToken}`
          },
          credentials: 'include'
        })
        .then(res => {
          console.log('enable2FA API response:', res);
          if (!res.ok) {
            throw new Error('Failed to enable 2FA');
          }
          return res.json();
        })
        .then(data => {
          console.log('enable2FA API data:', data);
          if (data.qrCode) {
            setQrCode(data.qrCode);
            toast.success('2FA enabled successfully!');
          } else {
            toast.error('Failed to enable 2FA');
            setError('Failed to enable 2FA');
          }
        })
        .catch(err => {
          toast.error('Failed to enable 2FA');
          setError('Failed to enable 2FA: ' + err.message);
          console.error('enable2FA API error:', err);
        });
      };
      enable2FA();
    }
  }, [sessionToken]);

  const handleVerify2FA = (e) => {
    e.preventDefault();

    fetch(API_URL('verify-2fa', 'auth'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionToken}`
      },
      body: JSON.stringify({ token }),
      credentials: 'include'
    })
    .then(res => {
      console.log('2FA Response:', res);
      if (!res.ok) {
        throw new Error('Invalid token');
      }
      return res.json();
    })
    .then(data => {
      dispatch(setUserDetails({
        username: data.username,
        role: data.role,
        token: data.token
      }));
      sessionStorage.setItem('token', data.token);
      sessionStorage.setItem('role', data.role); 
      toast.success('2FA verification successful!');
      navigate('/');
    })
    .catch(err => {
      toast.error('Failed to verify 2FA');
      setError('2FA verification error: ' + err.message);
      console.error('2FA verification API error:', err);
    });
  };

  return (
    <div className='verification-container'>
      <h2>Enable and Verify Two-Factor Authentication</h2>
      {qrCode ? (
        <div>
          <h3>Scan this QR code with your authenticator app or directly enter authentication code from the app:</h3>
          <img src={qrCode} alt="2FA QR Code" className='qr-code'/>
        </div>
      ) : (
        <p>Loading QR code...</p>
      )}
      <form onSubmit={handleVerify2FA} className="verification-form">
        {/* <input
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="Enter authentication code"
        /> */}

        <Box sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}>
                <TextField
                    required
                    id="outlined-required-token"
                    label="Enter authentication code"
                    type="text"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                    color="secondary"
                    focused
                    InputLabelProps={{ style: { color: 'darkviolet' } }}
                    sx={{
                    input: { color: 'navy' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'darkviolet' },
                        '&:hover fieldset': { borderColor: 'darkviolet' },
                        '&.Mui-focused fieldset': { borderColor: 'darkviolet' },
                    },
                    }}
                />
                </Box>
        <button type="submit" className="btn-verify">Verify 2FA</button>
      </form>
      {error && <div className="errors">{error}</div>}
    </div>
  );
};

export default Combined2FA;